// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueQuillEditor from "vue-quill-editor";
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
Vue.use(VueQuillEditor)
import 'babel-polyfill'; // 解决ie 不显示问题
import store from './utils/store.js'
import axios from 'axios';
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
Vue.prototype.axios = axios;


// 引入高德地图
import GaodeMap from 'vue-amap'
Vue.use(GaodeMap);
GaodeMap.initAMapApiLoader({
    key: '3628c42f654dc001c274a6f03e06c585',
    v:'1.4.4'
});


const i18n=new VueI18n({
    locale:localStorage.getItem('languageSet')||'zh',   //从localStorage里获取用户中英文选择，没有则默认中文
    messages:{
        'zh':require('./utils/cn.js'),
        'en':require('./utils/en.js')
    }
})

import vueSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Distpicker from 'v-distpicker'

Vue.component('v-distpicker', Distpicker)
import {post,fetch,patch,put} from './utils/http'
Vue.prototype.$post=post; // post
Vue.prototype.$fetch=fetch; // get
Vue.prototype.$patch=patch;
Vue.prototype.$put=put;

Vue.use(ElementUI,{zIndex: 9999999991 })
Vue.use(vueSwiper)
Vue.config.productionTip = false
/* eslint-disable no-new */
//

import Router from 'vue-router'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}


router.beforeEach((to, from, next) => {
  var Authorization = localStorage.getItem('Authorization')
  if (to.meta.auth) {
    if (Authorization) {
      next();
    } else {  

    }
  } else {
    next()
  }
  next()
})
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js